const LinearProgressLoader = () => {
  return (
    <div className="bg-white h-1 w-85">
      <div
        className="bg-primary h-full animate-progress-width"
        style={{
          animation: "progressWidth 5s ease-in-out infinite",
        }}
      />
      <style>
        {`
              @keyframes progressWidth {
                from {
                  width: 0%;
                }
                to {
                  width: 100%;
                }
              }
            `}
      </style>
    </div>
  )
}
export default LinearProgressLoader
